// Mirrors the backend upload limits in src/routes/v1/general.route.js (backend is the source of truth).
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;
export const UPLOAD_TOO_LARGE = 'File is larger than 50 MB.';
export const UPLOAD_WRONG_TYPE = 'Only PDF, JPG, PNG or phone photos (HEIC) are allowed.';
export const UPLOAD_ACCEPT = '.pdf,.jpg,.jpeg,.png,.heic,.heif,application/pdf,image/jpeg,image/png,image/heic,image/heif';

const HEIF_TYPES = ['image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence', 'application/octet-stream'];
const ALLOWED_UPLOAD_TYPES = {
    '.pdf': ['application/pdf'],
    '.jpg': ['image/jpeg', 'image/pjpeg'],
    '.jpeg': ['image/jpeg', 'image/pjpeg'],
    '.png': ['image/png'],
    '.heic': HEIF_TYPES,
    '.heif': HEIF_TYPES,
};

// Returns a user-facing message when the chosen file would be rejected, otherwise null (also null when no file).
export const uploadFileError = (file) => {
    if (typeof Blob === 'undefined' || !(file instanceof Blob)) return null;
    const name = String(file.name || '').toLowerCase();
    const ext = name.lastIndexOf('.') > 0 ? name.slice(name.lastIndexOf('.')) : '';
    const type = String(file.type || '').toLowerCase() || 'application/octet-stream';
    const allowed = ALLOWED_UPLOAD_TYPES[ext];
    if (!allowed || !allowed.includes(type)) return UPLOAD_WRONG_TYPE;
    if (file.size > MAX_UPLOAD_BYTES) return UPLOAD_TOO_LARGE;
    return null;
};
